let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dVwCr")).then(() => parcelRequire('hCRoC'));